<template lang="pug">
.stu-home
    div.preview 当前为预览状态，查看报告等操作暂不支持预览。
      button.button(@click='$router.go(-1)') 退出预览
    Noviceguide(v-if='guideState',@complete='complete')
    taskList(v-if='taskState',@del='queryTaskList',@gotoTask='gotoTask',@goHome='goHomeTask')
    Welcome(v-if='WelcomeState',:index='index',@addTrain='addTrain',@cancel="cancel")
    component(:is='assemblyName',v-if='assemblyName',:cont='contList[controlIndex]',@Ook='Ook',@Determine='Determine')
    component(:is='EjectScene',v-if='EjectScene',:cont='SceneList[SceneIndex]',@SignOut='SignOut',@addOne='addOne')
    div.top-nav
      div.left-nav
        img.logo(:src="logoNav",@click='goback')
        li(v-for='(v,idx) in list',:class="{active:idx===index}",@click='changeNav(idx)').text {{v}}
      div(style='flex:1;')
      div.rigth-nav
        i.icon-renwu1.iconfont(@click='icontask=!icontask' style='padding-right:8px;')
        p.task-text(@click='icontask=!icontask' ) 任务
        p.task-text(style='color:#D8D8D8;padding-right: 8px;padding-left: 26px;') |
        p.task-text 退出实训
        div.task(v-if='taskIndex!==-1&&taskList[taskIndex]&&!taskState&&icontask')
          //- p.title 通知
          div.task-content(@click="goHome(true)")
            Badge(dot)
              Icon.icon-renwu1.iconfont(:size='24',color='rgba(80, 143, 244, 1)')
            div.text-content {{taskList[taskIndex].taskContent}}
        // 抽屉
      zxDrawer(align="up",:closeable="true",:z-index="999999",@close="()=>{ DrawerStatr = false }")
        div(v-if="DrawerStatr").drawer-Statr
          ul(:style="drawerStyle()")
            li(v-for="(item,idx) in completeTaskList",@click="goTask(idx,item)",:class="{'active':taskIndex === idx}").name
              Icon(type="ios-checkmark",size="16",color="#F5A623",:style="getIconShow(item.complete)")
              span  {{item.taskName}}
    right-column(@goHome='goHome')
    search-modal()
    analyze-modal
    // 所有场景列表
    div.main-hall(v-for='(v,idx) in hallList',:class="`hall${idx}`",@click='gotocontrol(v.departmentName,SceneList[SceneIndex]&&SceneList[SceneIndex].departmentName === v.departmentName||(sceneIndex1.index1===idx||sceneIndex1.index2===idx),idx,v)') {{v.departmentName}}
      p.circular(v-if='shoWHall2(v,idx)')
</template>
<script>
import { mapState } from "vuex";
import Drawer from "vue-simple-drawer";
import docase from "@/mixins/case/doCase";
import rightColumn from "@/components/doCase/RightColumn"; // 右侧按钮控件
import searchModal from "@/components/doCase/rightColumn/searchModal"; // 右侧导航搜索控件
import analyzeModal from "@/components/doCase/rightColumn/analyzeModal"; // 右侧导航分析控件
import Noviceguide from "@/components/Novice_guide/index"; // 新手引导控件
import Welcome from "@/components/doCase/Welcome"; // 欢迎进入控件
import ArrControl from "@/components/doCase/doControl/ArrControl"; // 欢迎进入控件
import SINGLETEXT from "@/components/doCase/doControl/SINGLETEXT"; // 欢迎进入控件
import LEADERSHIPOFFICE from "@/components/doCase/doControl/LEADERSHIPOFFICE"; // 领导办公室控件
import MYOFFICE from "@/components/doCase/doControl/MYOFFICE"; // 我的办公室
import SURVEY from "@/components/department/survey"; // 现场调研
import Unit from "@/components/doCase/doControl/Unit"; // 自定义场景
import POLLINGCENTER from "@/components/doCase/doControl/POLLINGCENTER"; // 我的办公室
import taskList from "@/components/doCase/taskList"; // 我的通知
export default {
  mixins: [docase],
  components: {
    "right-column": rightColumn,
    searchModal,
    zxDrawer: Drawer,
    analyzeModal,
    Noviceguide,
    Welcome,
    SINGLETEXT,
    LEADERSHIPOFFICE,
    ArrControl,
    MYOFFICE,
    SURVEY,
    POLLINGCENTER,
    taskList,
    UnitA: Unit, // 5
    UnitB: Unit, // 6
    UnitC: Unit, // 7
    UnitD: Unit, // 8
    UnitE: Unit, // 9
    UnitF: Unit, // 10
    UnitG: Unit, // 11
    UnitH: Unit, // 12
    UnitI: Unit, // 13
    UnitJ: Unit, // 14
    UnitK: Unit, // 15
    UnitL: Unit, // 16
    UnitM: Unit, // 17
    UnitN: Unit, // 18
    UnitO: Unit, // 19
    UnitP: Unit, // 20
    UnitQ: Unit // 21
  },
  // code
  provide() {
    return {
      Completed: this.Completed === "false" ? false : this.Completed
    };
  },
  name: "preview",
  data() {
    return {
      Completed: this.$route.query.state,
      /** 导航栏抽屉状态 */
      DrawerStatr: false,
      completeTaskList: [],
      taskState: false,
      sta: true,
      icontask: true,
      willDoIndex: 0,
      AloneControl: ["MATERIALANALYSISPROBLEM", "DIALOGUE"],
      controlIndex: 0, // 当前控件进入到了第几个
      controlList: [], // 所有的大厅空间
      contList: [], // 处理后的控件列表
      EjectControl: "", // 弹出什么空间
      hashList: [], // 去过的历史场景
      SceneList: [], // 场景列表
      contState: false, // 控件显示状态
      SceneIndex: -1, // 当前第几个场景
      EjectScene: "", // 弹出什么场景
      taskList: [],
      temporary: -1,
      taskIndex: -1, // 当前第几个任务
      index: -1, // 进行到了什么阶段
      guideState: false, // 新手引导是否显示
      // step: ["FORMULATE", "EXECUTE", "ASSESS", "FINALITY"],
      list: ["政策制定", "政策执行", "政策评估", "政策终结"],
      WelcomeState: true, // 欢迎界面是否显示
      hallList: [] // 单阶段的所有部门
    };
  },
  computed: {
    ...mapState(["doCase"]),
    step() {
      return this.$store.state.Case.caseValue;
    },
    assemblyName() {
      if (Array.isArray(this.controlList[this.controlIndex])) {
        return this.controlList[this.controlIndex].type;
        // eslint-disable-next-line
      } else if (this.controlIndex + 1 > this.controlList.length || this.contState) {
        return false;
      } else {
        return "ArrControl";
      }
    },
    shoWHall() {
      console.log(this.SceneList);
      const find = value => {
        return value.logicNum === this.SceneIndex;
      };
      if (this.SceneList.find(find) && this.SceneList.find(find).logicNum === this.SceneIndex) {
        return this.SceneList.findIndex(find);
      }
      return false;
    },
    sceneIndex1() {
      if (!this.SceneList[this.shoWHall]) {
        return -1;
      }
      const find = value => {
        return value.departmentName === this.SceneList[this.shoWHall].departmentName;
      };
      return {
        index1: this.hallList.findIndex(find),
        index2: this.hallList.find(find).logicNum
      };
    }
  },
  mounted() {
    this.queryTaskList();
    this.getNavList();
  },
  created() {
    // -将需要进行到的状态存储至willDoIndex
    this.willDoIndex = sessionStorage.getItem("willDoIndex");
    console.log(this.willDoIndex);
    // eslint-disable-next-line no-restricted-syntax
    for (const i of this.step) {
      // - console.log(i);
      this.queryCaseBasicInformation(i);
    }

    if (sessionStorage.getItem("doIndex")) {
      this.index = +sessionStorage.getItem("doIndex");
    }
    if (this.index !== -1) {
      this.WelcomeState = false; // 欢迎界面是否显示
      this.queryHallList();
    }
    this.oneCase();
    console.log(this);
  },
  methods: {
    async getNavList() {
      try {
        const { data } = await this.$http.getCaseHallNavbarList(this.$store.state.Case.basic.id);
        this.list = data.data.sort((a, b) => a.sortNo - b.sortNo).map(v => v.stepName);
      } catch (error) {
        console.log(error);
      }
    },
    async goTask(idx, sta) {
      if (sta.complete) {
        this.taskIndex = idx;
        this.icontask = true;
        this.temporary = 0;
        const data = {
          chId: this.doCase.caseData[this.step[this.index]].tsId
        };
        await this.$http.listCaseDepartmentStepByChid(data).then(res => {
          this.hallList = res.data.data;
          return true;
        });
        await this.queryTsak(true);
        await this.queryScene(false, true);
        await this.goHome();
        console.log(3);
        this.DrawerStatr = false;
      } else {
        this.$Message.error("暂未到达该任务");
      }
    },
    getIconShow(sta) {
      if (!sta) {
        return "visibility: hidden;";
      }
    },
    drawerStyle() {
      let left = "";
      if (this.index === 0) {
        // - left = "left: 188px;";
        left = "left: 138px;";
      } else if (this.index === 1) {
        // - left = "left: 280px;";
        left = "left: 230px;";
      } else if (this.index === 2) {
        // - left = "left: 365px;";
        left = "left: 315px;";
      } else if (this.index === 3) {
        // - left = "left: 444px;";
        left = "left: 394px;";
      }
      return left;
    },
    /** 更新做到哪个任务 */
    createOrUpdateExperimentMember(index) {
      const data = {
        experimentId: this.doCase.experimentId,
        pyId: this.doCase.caseId,
        userId: this.$role.code,
        classId: sessionStorage.getItem("classId"),
        caseHallId: this.doCase.caseData[this.step[this.index]].tsId,
        executeTaskNumber: index
      };
      this.$http.createOrUpdateExperimentMember(data).then(res => {
        console.log(res);
      });
    },
    queryListStuControl() {
      console.log(this.contList[this.controlIndex]);
      const data = {
        caseHallId: this.doCase.caseData[this.step[this.index]].tsId,
        classId: sessionStorage.getItem("classId"),
        experimentId: this.doCase.experimentId,
        pyId: this.doCase.caseId,
        userId: this.$role.code
      };
      return this.$http.listStuControl(data).then(res => {
        if (!res.data.data) {
          return;
        }
        console.log(res.data.data);
        console.log(this.SceneList);
        if (this.taskIndex === 0) {
          return;
        }
        const taskId = this.taskList[this.taskIndex - 1].id;
        if (
          !res.data.data.find(value => {
            return value.taId === taskId;
          }) ||
          res.data.data.find(value => {
            return value.taId === taskId;
          }).controlTypes !== "FILLBLANKS"
        ) {
          return;
        }
        if (
          !res.data.data.find(value => {
            return value.taId === taskId;
          }) ||
          !res.data.data.find(value => {
            return value.taId === taskId;
          }).questionAnswer ||
          !Array.isArray(
            JSON.parse(
              res.data.data.find(value => {
                return value.taId === taskId;
              }).questionAnswer
            )
          )
        ) {
          return;
        }
        const questionAnswer = JSON.parse(
          res.data.data.find(value => {
            return value.taId === taskId;
          }).questionAnswer
        ).map(item => {
          const data2 = this.SceneList.find(value => {
            return value.caseDepartmentId === item.department;
          });
          console.log(data2, item);
          if (data2) {
            data2.sta = true;
          }
          return data2;
        });
        console.log(questionAnswer);
        this.SceneList = questionAnswer;
      });
    },

    shoWHall2(v, idx) {
      const b = this.SceneList.find(value => {
        if (value) {
          return value.caseDepartmentId === v.id;
        }
        return undefined;
      });
      if (b && b.sta) {
        return b.sta;
      }
      return (
        (this.SceneList[this.SceneIndex] &&
          this.SceneList[this.SceneIndex].departmentName === v.departmentName) ||
        this.sceneIndex1.index1 === idx ||
        this.sceneIndex1.index2 === idx
      );
    },
    goHomeTask() {
      this.taskState = false;
    },
    gotoTask(index) {
      this.taskState = false;
      this.index = index.stageIndex;
      this.taskIndex = index.taskIndex;
      this.queryScene(true);
    },
    queryTaskList() {
      // 查询内部通知
      const data = {
        experimentId: this.doCase.experimentId,
        userId: this.$role.code,
        type: "内部任务通知"
      };
      this.$http.listInternalNotification(data).then(res => {
        if (res.data.data.list) {
          this.$store.commit("doEditTaskList", res.data.data.list);
        }
      });
    },
    addOne(index) {
      // 加场景
      if (this.SceneList.length > this.SceneIndex + 1 && this.sta) {
        this.sta = false;
        this.SceneIndex += 1;
      }
      if (this.SceneList.length <= this.SceneIndex + 1) {
        this.taskIndex = index + 1;
        this.icontask = true;
        this.queryScene();
      }
      this.queryListStuControl();
    },
    async goHome(value) {
      // 任何页面返回首页阶段
      this.icontask = true;
      this.taskState = false;
      this.EjectScene = "";
      this.SceneIndex = this.temporary;
      this.sta = true;
      await this.queryListStuControl();
      if (!this.taskList[this.taskIndex]) {
        // 如果当前场景下没有任务了
        this.WelcomeState = true; // 欢迎界面是否显示
      }
      if (value) {
        this.gotocontrol("通知");
      }
    },
    SignOut() {
      //  场景控件关闭事件
      this.EjectScene = "";
      if (this.SceneList[this.SceneIndex] && this.SceneList[this.SceneIndex].sta) {
        this.SceneList.splice(this.SceneIndex, 1);
        this.SceneIndex = 0;
        if (this.SceneList.length !== 0) {
          return;
        }
      }
      if (this.SceneList.length > this.SceneIndex + 1) {
        this.SceneList.splice(0, 1);
      } else if (this.taskList.length > this.taskIndex + 1) {
        this.taskIndex += 1;
        this.icontask = true;
        this.queryScene();
      } else {
        this.WelcomeState = true; // 欢迎界面是否显示

        // this.queryHallList();
      }
    },
    Determine() {
      this.contState = true;
      if (this.controlIndex + 1 < this.contList.length) {
        this.controlIndex += 1;
        setTimeout(() => {
          this.contState = false;
        });
        this.$forceUpdate();
        return;
      }
      setTimeout(() => {
        this.contState = true;
      });
      this.queryTsak();
      this.$forceUpdate();
      this.icontask = true;
    },
    gotocontrol(v, b, index, item) {
      this.SceneList.forEach(() => {
        if (
          this.SceneList.findIndex(value => {
            return !value;
          }) !== -1
        ) {
          this.SceneList.splice(
            this.SceneList.findIndex(value => {
              return !value;
            }),
            1
          );
        }
      });
      this.icontask = false;
      /** 进入任务控件事件 */
      let state = false;
      if (item) {
        const find2 = value => {
          return value.caseDepartmentId === item.id;
        };
        if (this.SceneList.find(find2) && this.SceneList.find(find2).sta) {
          this.SceneIndex = this.SceneList.findIndex(find2);
          this.EjectScene = this.SceneList.find(find2).scene;
          return;
        }
      }
      console.log(this.SceneIndex);
      this.SceneIndex = 0;
      if (this.SceneList[this.SceneIndex] && this.SceneList[this.SceneIndex].departmentName === v) {
        state = true;
      } else if (v === "通知") {
        state = true;
        if (this.shoWHall) {
          // eslint-disable-next-line no-param-reassign
          index = this.sceneIndex1;
        } else {
          const f = value => {
            return value.departmentName === this.SceneList[this.SceneIndex].departmentName;
          };
          // eslint-disable-next-line no-param-reassign
          index = this.hallList.findIndex(f);
        }
      }
      if (b) {
        state = true;
      }

      if (state) {
        const find = value => {
          // eslint-disable-next-line no-param-reassign
          index = index.index1 || index;
          return value.departmentName === this.hallList[index].departmentName;
        };
        this.hashList.push(this.SceneIndex);

        this.SceneIndex = this.SceneList.findIndex(find);
        if (this.SceneIndex !== 0) {
          [this.SceneList[0], this.SceneList[this.SceneIndex]] = [
            this.SceneList[this.SceneIndex],
            this.SceneList[0]
          ];
        }
        this.SceneIndex = 0;
        this.temporary = this.SceneIndex;

        this.EjectScene = this.SceneList.find(find).scene;
        // this.EjectScene = this.SceneList[this.SceneIndex].scene;
      }
      //
      //
    },
    Ook() {
      /** 关闭大厅控件事件 */
      const value = {
        index: this.step[this.index],
        data: this.controlList[this.controlIndex]
      };
      this.$store.commit("pushHallControl", value);
      // 先往vuex里储存进度

      if (this.controlList.length === this.controlIndex + 1) {
        /** 如果大厅控件没有了 */
        this.EjectControl = "";
        // - console.log(this);
        // /** 开启欢迎控件,开始政策制定 */
        // this.WelcomeState = true;
        /** 查询任务 开启任务通知 */
        this.queryTsak();
      }
    },
    queryTsak(value) {
      /** 查询所有任务列表 */
      const data = {
        chId: this.doCase.caseData[this.step[this.index]].tsId
      };
      return this.$http.listTaskByChid(data).then(res => {
        this.taskList = res.data.data;
        if (!value) {
          this.taskIndex = 0;
          this.queryScene();
        }
      });
    },
    complete() {
      // 新手引导关闭事件
      this.guideState = false;
      this.WelcomeState = true;
    },
    changeNav(index) {
      /** 导航栏点击事件 */
      // - if (+sessionStorage.getItem("doIndex") < index) {
      // -   return this.$Message.error("还未到达该步骤!");
      // - }
      const data = {
        caseHallId: this.doCase.caseData[this.step[index]].tsId,
        experimentId: this.doCase.experimentId
      };
      this.$http.queryTaskByStu(data).then(res => {
        if (
          res.data.data.find(value => {
            return !!value.complete;
          })
        ) {
          this.completeTaskList = res.data.data;
          this.DrawerStatr = !this.DrawerStatr;
          this.index = index;
          sessionStorage.setItem("doIndex", this.index);
        } else {
          return this.$Message.error("还未到达该步骤!");
        }
      });
      // - this.queryHallList();
    },
    cancel() {
      // 取消提交，回到上一个任务
      this.WelcomeState = false;
      const index = this.completeTaskList.length - 1;
      const task = this.completeTaskList[index];
      this.goTask(index, task);
    },
    addTrain() {
      /** 关闭欢迎界面 */
      this.index += 1;
      this.controlIndex = 0;
      this.WelcomeState = false;
      sessionStorage.setItem("doIndex", this.index);
      this.queryHallList();
    },
    goback() {
      /** 返回案例列表按钮 */
      this.$router.go(-1);
    },
    queryHallList() {
      /** 查询案例阶段下的所有大厅 */
      if (!this.doCase.caseData[this.step[this.index]].tsId) {
        setTimeout(() => {
          // eslint-disable-next-line no-return-assign
          return (this.WelcomeState = true);
        });
      }
      const data = {
        chId: this.doCase.caseData[this.step[this.index]].tsId
      };
      this.$http.listCaseDepartmentStepByChid(data).then(res => {
        this.WelcomeState = false;
        this.hallList = res.data.data;
        this.$store.commit("editAllHall", {
          index: this.index,
          data: res.data.data
        });
        this.queryControl();
        this.queryTsak();
      });
    },
    oneCase() {
      /** 进入案例 查询是否第一次进入 */
      const data = {
        experimentId: this.doCase.experimentId,
        userId: this.$role.code
      };
      this.$http.selectStuIsFirstEntry(data).then(res => {
        if (!res.data.data) {
          // - this.guideState = true;
          const data2 = {
            isFirstEntry: true,
            experimentId: this.doCase.experimentId,
            pyId: this.doCase.caseId,
            userId: this.$role.code,
            classId: sessionStorage.getItem("classId")
          };
          this.$http.createOrUpdateExperimentMember(data2);
        }
      });
    },
    queryScene(b, v) {
      return new Promise(rej => {
        if (this.taskIndex === this.taskList.length) {
          this.SignOut();
        }
        const data = {
          taId: this.taskList[this.taskIndex].id
        };
        this.$http.listTaskScenarioByTaid(data).then(res => {
          this.SceneList = res.data.data.map(i => {
            i.tsId = i.id;
            return i;
          });
          console.log(2);
          if (!v) {
            this.SceneIndex = 0;
          }
          if (this.SceneList.length === 0) {
            this.WelcomeState = true;
          } else {
            this.WelcomeState = false;
          }
          if (b) {
            this.$nextTick(() => {
              this.gotocontrol("通知");
            });
          }
          rej();
        });
      });
    },
    queryControl() {
      if (!this.doCase.caseData[this.step[this.index]].tsId) {
        // eslint-disable-next-line no-param-reassign
        // eslint-disable-next-line no-return-assign
        return (this.WelcomeState = true);
      }
      const data = {
        tsId: this.doCase.caseData[this.step[this.index]].tsId,
        module: this.$store.state.task.modules
      };

      this.$http.listControlByTsid(data).then(res => {
        console.log("执行执行6666");
        this.controlList = res.data.data;
      });
    },
    queryCaseBasicInformation(index2) {
      const data = {
        caseStep: index2,
        pyId: this.doCase.caseId
      };
      this.$http.getCasehallByPyIdAndCaseStep(data).then(res => {
        console.log(res);
        if (!res.data.data) {
          return;
        }
        const data1 = {
          index: index2,
          tsId: res.data.data.id,
          stageShow: res.data.data.stageShow
        };
        this.$store.commit("postStuCaseInformation", data1);
        const data3 = {
          caseExperimentId: this.doCase.caseId,
          experimentId: this.doCase.experimentId
        };
        // sessionStorage.setItem("doIndex", -1);
        this.$store.commit("postStuCaseId", data3);
      });
    }
  },
  watch: {
    controlList: {
      handler() {
        console.log("变化!!");
        /** 开始大厅的控件 */
        const contList = [];
        let data = [];
        let num = 0;
        this.controlList.forEach((element, index) => {
          if (num === +element.pageNumber) {
            if (this.AloneControl.indexOf(element.type) === -1) {
              data.push(element);
              if (index === this.controlList.length - 1) {
                if (data.length !== 0) {
                  contList.push(data);
                }
              }
            } else {
              if (data.length !== 0) {
                contList.push(data);
              }
              contList.push(element);
              data = [];
            }
          } else if (this.AloneControl.indexOf(element.type) === -1) {
            if (data.length !== 0) {
              contList.push(data);
            }
            data = [];
            data.push(element);
            if (index === this.controlList.length - 1) {
              contList.push(data);
            }
          } else {
            if (data.length !== 0) {
              contList.push(data);
            }
            contList.push(element);
            data = [];
          }
          num = +element.pageNumber;
        });
        console.log(contList, "contList");
        this.contList = contList;
        // - console.log(this.contList);
        this.contState = false;
        // - console.log(this.assemblyName);
        if (this.contList.length === 0) {
          console.log("没有!");
          this.Determine();
        }
        this.queryListStuControl();
      },
      deep: true
    },
    taskList() {
      // 第一个任务触发事件
      this.icontask = true;
      // - this.queryScene();
    },
    taskIndex() {
      /** 进度 */

      const speed = ((this.taskIndex + 1) / this.taskList.length) * 25 * this.index;
      if (speed > +sessionStorage.getItem("schedule")) {
        this.SpeedOfProgress(speed);
      }
      this.queryTaskList();
      if (this.doCase.taskList.length !== 0) {
        /** 如果已经有保存的任务了 判断一下该任务保存过没 */
        if (this.taskIndex === this.taskList.length) {
          this.SignOut();
        }
        const find = value => {
          return value.taskId === this.taskList[this.taskIndex].id;
        };
        // this.doCase.taskList.find(find)

        if (this.doCase.taskList.find(find)) {
          /** 如果任务存在 则不添加 */
        } else {
          /** 否则创建新任务 */
          const data = {
            content: this.taskList[this.taskIndex].taskContent,
            experimentId: this.doCase.experimentId,
            taskId: this.taskList[this.taskIndex].id,
            userId: this.$role.code
          };
          this.$http.createInternalNotification(data).then(() => {});
        }
      } else {
        const data = {
          content: this.taskList[this.taskIndex].taskContent,
          experimentId: this.doCase.experimentId,
          taskId: this.taskList[this.taskIndex].id,
          userId: this.$role.code
        };
        this.$http.createInternalNotification(data).then(() => {});
      }
      this.createOrUpdateExperimentMember(this.taskIndex);
    }
  }
};
</script>

<style lang="stylus" scoped>
.stu-home
  background url('../../assets/case/backrgound.png')
  background-size 100% 100%
  height 100vh
  padding-top 40px
  .preview
    position fixed
    text-align left
    width 100%
    height 40px
    left 0
    top 0
    z-index 1000
    background-color #fff
    padding-left 150px
    font-size 12px
    font-family MicrosoftYaHeiUI
    color grey
    line-height 40px
    .button
      position absolute
      right 160px
      width 80px
      height 28px
      background #4a90e2
      border-radius 4px
      top 50%
      margin-top -14px
      padding 0
      font-size 14px
      color #ffffff
      border none
      outline none
      line-height 28px
  >>>.mask
    top 59px !important
    position absolute
    background #ffffff00
  >>>.vue-simple-drawer
    background #333333d9 !important
  >>>.vue-simple-drawer.up
    top 59px !important
    position absolute
  .top-nav
    height 60px
    z-index 6
    position relative
    // - display flex
    background rgba(33, 33, 33, 1)
    box-shadow 0px -1px 0px 0px rgba(217, 217, 217, 0.5)
    font-size 14px
    font-family MicrosoftYaHeiUI
    color #767676
    line-height 18px
    min-width 1100px
    .drawer-Statr
      text-align left
      .active
        color #ffffff !important
      ul
        width 334px
        position relative
        display inline-block
        .name
          cursor pointer
          margin 24px
          font-size 14px
          font-family MicrosoftYaHeiUI
          color #d7d7d7
          line-height 18px
    .left-nav
      height 100%
      // - display flex
      // - align-items center
      // - margin-left 144px
      margin-left 93px
      text-align initial
      float left
      line-height 60px
      .active
        font-weight bold
        color #ffffff
    .logo
      height 24px
      margin-right 50px
      cursor pointer
    .text
      cursor pointer
      margin 15px
      display inline
  .rigth-nav
    color #ffffff
    height 100%
    margin-right 93px
    // - display flex
    // - justify-content flex-end
    // - flex 2 1 0%
    // - align-items center
    // - width 352px
    width 160px
    line-height 60px
    float right
    .icon-renwu1
      font-size 16px
    .task-text
      // - padding-left 4px
      // - padding-right 10px
      font-size 14px
      display inline
      font-family MicrosoftYaHeiUI
      color rgba(255, 255, 255, 1)
      line-height 18px
      cursor pointer
    .task
      position relative
      // - left 200px
      right 110px
      z-index 100
      // - top 85px
      width 300px
      height 80px
      background rgba(255, 255, 255, 1)
      box-shadow 0px 2px 6px 0px rgba(180, 181, 186, 0.66)
      border-radius 8px
      text-align left
      .icon
        // margin-right 25px
      .title
        padding 16px 14px
        font-size 14px
        font-family MicrosoftYaHeiUI
        color rgba(42, 46, 54, 1)
        line-height 18px
      .task-content
        height 72px
        padding 20px
        cursor pointer
        // - border-bottom 1px solid #80808033
        border-top-left-radius 8px
        border-top-right-radius 8px
        background rgba(246, 250, 254, 1)
        box-shadow 0px -1px 0px 0px rgba(128, 128, 128, 0.2)
        font-size 14px
        font-family MicrosoftYaHeiUI
        color rgba(42, 46, 54, 1)
        line-height 18px
        .text-content
          display unset
          padding-left 25px
          cursor pointer
      .task-bottom
        text-align center
        line-height 40px
        button
          border none
          outline none
          background none
          text-align center
          font-size 12px
          font-family MicrosoftYaHeiUI
          color rgba(53, 126, 212, 1)
          line-height 15px
  .main-hall
    height 35px
    position absolute
    background rgba(32, 120, 223, 1)
    box-shadow 0px 1px 6px 0px rgba(0, 0, 0, 0.23)
    border-radius 4px 4px 4px 0px
    min-width 35px
    border 1px solid rgba(255, 255, 255, 1)
    font-size 16px
    font-family MicrosoftYaHeiUI
    color rgba(255, 255, 255, 1)
    padding 6px
    cursor pointer
    text-align center
  .hall0
    left 50%
    top 51%
  .hall1
    left 62%
    top 26%
  .hall2
    left 12%
    top 33%
  .hall3
    left 61%
    top 62%
  .hall4
    left 48%
    top 17%
  .hall5
    left 24%
    top 48%
  .hall6
    left 12%
    top 66%
  .hall7
    left 31%
    top 17%
  .hall8
    left 75%
    top 63%
  .hall9
    left 43%
    top 69%
  .hall10
    left 39%
    top 29%
  .hall11
    left 89%
    top 44%
.circular
  width 12px
  height 12px
  border-radius 50%
  background #8F8F8FFF
  color #fff
  text-align center
  line-height 30px
  font-size 18px
  border 4px solid #D7D7D7FF
  position absolute
  right -10px
  top 0
  transform translate(-50%, -50%)
  box-sizing border-box
  &:after
    content ''
    height 32px
    width 32px
    display block
    border-radius 36px
    position absolute
    top -4px
    left -4px
    background rgba(213, 81, 64, 1)
    border 4px solid #D7D7D7FF
    animation expand 1.6s infinite
    animation-delay 1.8s
@keyframes expand
  from
    width 12px
    height 12px
    top -4px
    left -4px
  to
    width 32px
    height 32px
    top -12px
    left -12px
    border-color #8F8F8FFF
</style>
